import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { CreateNewBusinessComponent } from 'src/app/shared/components/create-new-business/create-new-business.component';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-stat-cards',
  templateUrl: './stat-cards.component.html',
  styleUrls: ['./stat-cards.component.scss']
})
export class StatCardsComponent implements OnInit, OnDestroy {
  public loader: boolean = true;
  private _apiSubscription: Subscription;
  businessListData: any[] = []
  constructor(private _apiService: ApiService, private router: Router, private _modelRef: MatDialog) {
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_BUSINESS_LIST_RESULT){
        this.businessListData = []
        if(resData.result){
          resData.result.forEach((element:any) => {
            if(element.addressInfo){
              element.addressInfo = JSON.parse(element.addressInfo)

            }
           
            this.businessListData.push(element)
          });
        }
        if(localStorage.getItem('newlyCreatedBusinessHash') && localStorage.getItem('newlyCreatedBusinessHash') != 'null'){
          let bHash = localStorage.getItem('newlyCreatedBusinessHash')
          const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
            width: "600px",
            data : {
              title : 'SUCCESS!',
              message : 'Your business created successfully. Now upload business and shop ownership documents in Documents section. Once they will be verified your business will be ready to get bookings from People mobile apps and websites.',
              okbtn : ' Go to Documents',
              cancelbtn : 'Ok',
              type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
            },
            disableClose : true
          });
          dialogRef.afterClosed().subscribe(result=>{
            console.log(result);
            if(result){ 
              localStorage.removeItem('newlyCreatedBusinessHash')
              this.router.navigate(["/businesses", "details", "documents"], {
                queryParams: { entityHash: bHash },
              });
          
            }
            else {
              localStorage.removeItem('newlyCreatedBusinessHash')
            }
          })
        }
      }
      this.loader = false;
    });
   }

  ngOnInit(): void {
    
  }
  viewDetails(item: any){
    if(item.subscriptionInfo && item.subscriptionInfo != 'null'){
      this.router.navigate(['/businesses','details'], {queryParams: {'entityHash' : item.hashId}})
    }
    else{
      const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
        width: '600px',
        data : {
          title : 'Subscription expired',
          message : 'The current pack for this business has expired. Recharge now to use all the premium features without any restrictions.',
          okbtn : 'Renew',
          cancelbtn : 'Continue free use ',
          type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
        },
        disableClose : true
      });
      dialogRef.afterClosed().subscribe(result=>{
        console.log(result);
        if(result){ 
          this.router.navigate(["/businesses", "details", "plan-and-renew"], {
            queryParams: { entityHash: item.hashId },
          });
        }
        else{
          this.router.navigate(['/businesses','details'], {queryParams: {'entityHash' : item.hashId}})
        }
      })
    }
    // console.log(entityHash);

    
  }

  createNewBusiness(){
    this._modelRef.open(CreateNewBusinessComponent, {
      width: '500px',
      data: {
        title: 'Create Business',
        ref: this._modelRef
      },
    });
}

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe()
  }
  
}
